import { useEffect, useState } from "react";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import Image from "src/components/elements/Image";
import { isSVGString } from "src/helpers";
import { classNames } from "src/helpers/classNames";
import HeaderMenuItem from "./HeaderMenuItem";
import { useParams } from "react-router-dom";

const HeaderMenuGroup = ({ data, group_id, searchTerm = "", mordernDesign = false, dropdownPosition = "bottom-left", handleClick = () => {} }) => {
  const [imageClassName, setImageClassName] = useState("");
  const [menuItems, setMenuItems] = useState([]);

  const { content_value } = useParams();

  useEffect(() => {
    let visibleMenuItems = data.submenu || [];

    if (searchTerm) {
      const lowercaseSearchTerm = searchTerm.toLowerCase();
      visibleMenuItems = visibleMenuItems.filter((subitem) => subitem.name.toLowerCase().includes(lowercaseSearchTerm));
    }

    setMenuItems(visibleMenuItems);
  }, [data.submenu, searchTerm]);

  const isGroupActive = () => {
    return Boolean(data?.submenu?.find((item) => item?.slug === content_value));
  };

  const getDropdownPositionClass = () => {
    switch (dropdownPosition) {
      case "left":
        return "left-0";
      case "right":
        return "right-0";
      case "center":
        return "left-1/2 -translate-x-1/2";
      case "bottom-left":
        return "right-56 top-0";
      default:
        return "left-0 top-9";
    }
  };

  const iconImage = () => {
    if (!data.image) return null;

    return (
      <div className={classNames("nav-icon mr-2 h-5 w-5 flex-shrink-0", isSVGString(data.image) ? "" : "flex items-center justify-center", imageClassName)}>
        {isSVGString(data.image) ? (
          <div
            dangerouslySetInnerHTML={{
              __html: data.image.replace(/stroke-width="[^"]*"/g, 'stroke-width="1.7"'),
            }}
          />
        ) : (
          <Image
            src={data.image}
            alt="Menu image"
            classes={imageClassName}
            onError={() => setImageClassName("hidden")}
          />
        )}
      </div>
    );
  };

  if (menuItems.length === 1 && !data.subMenuFilteredDown) {
    return (
      <HeaderMenuItem
        handleClick={handleClick}
        data={menuItems[0]}
        group_id={group_id}
        image={data?.image}
        searchTerm={searchTerm}
        mordernDesign={mordernDesign}
      />
    );
  }

  const buttonClasses = classNames(
    "group/dropdown flex min-h-10 items-center space-x-1 rounded px-3 transition-all",
    mordernDesign ? "hover:bg-leftNavActiveColor hover:text-leftNavActiveTextColor" : "hover:bg-headerMenuActiveBgColor hover:text-headerMenuActiveTextColor",
    isGroupActive() ? (mordernDesign ? "bg-leftNavActiveColor text-leftNavActiveTextColor" : "bg-headerMenuActiveBgColor text-headerMenuActiveTextColor") : mordernDesign ? "text-leftNavTextColor" : "text-headerTextColor",
  );

  return (
    <div className="group/item relative">
      <button
        type="button"
        className={buttonClasses}>
        <div className="flex items-center">
          {iconImage()}
          <span className="whitespace-nowrap text-sm font-medium">{data.name}</span>
        </div>
        <ChevronDownIcon className="h-4 w-4 stroke-2 transition-transform group-hover/item:rotate-180" />
      </button>

      <div
        className={classNames(
          "absolute z-[100] mt-2 min-w-48 rounded-md bg-headerColor shadow-lg ring-1 ring-black ring-opacity-5",
          "invisible max-h-0 overflow-hidden opacity-0 transition-all",
          "group-hover/item:visible group-hover/item:max-h-[600px] group-hover/item:opacity-100",
          mordernDesign ? "bg-leftNavColor" : "bg-headerColor",
          getDropdownPositionClass(),
        )}>
        <div className="space-y-1 p-1">
          {menuItems.map((subitem) => (
            <HeaderMenuItem
              key={subitem._id}
              data={subitem}
              image={subitem?.image}
              group_id={group_id}
              searchTerm={searchTerm}
              handleClick={handleClick}
              mordernDesign={mordernDesign}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default HeaderMenuGroup;
